import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
            light: '#42a5f5',
            dark: '#1565c0'
        },
        secondary: {
            main: '#dc004e',
            light: '#ff4081',
            dark: '#c51162'
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff'
        },
        error: {
            main: '#f44336'
        },
        success: {
            main: '#4caf50'
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 500,
            fontSize: '2.5rem'
        },
        h2: {
            fontWeight: 500,
            fontSize: '2rem'
        },
        h3: {
            fontWeight: 500,
            fontSize: '1.75rem'
        },
        h4: {
            fontWeight: 500,
            fontSize: '1.5rem'
        },
        h5: {
            fontWeight: 500,
            fontSize: '1.25rem'
        },
        h6: {
            fontWeight: 500,
            fontSize: '1rem'
        },
        button: {
            textTransform: 'none'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px'
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    }
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small'
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 12
                }
            }
        }
    },
    shape: {
        borderRadius: 8
    }
});

export default theme;
